

const allHolidays = {
    "standby": {
        name: "",
        short_name: "",
        long_name: "",
        startDate: "",
        endDate: "",
        cta_url: "",
        name_of_sale: "",
        name_of_sale_lower: "",
        slug_name: "",
        adjective: "Biggest",
        adjective_lower: "biggest",
        list_of_copy: []
    },
    "new_years": {
        name: "New Year's",
        short_name: "New Year's",
        long_name: "New Year's",
        startDate: "2025-12-26",
        endDate: "2026-01-03",
        cta_url: "/offer/new-years-offer",
        name_of_sale: "New Year's Offer",
        name_of_sale_lower: "new year's offer",
        slug_name: "new_years",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "New Year's is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "valentines": {
        name: "Valentine's Day",
        short_name: "Valentine's Day",
        long_name: "Valentine's Day",
        startDate: "2026-02-09",
        endDate: "2026-02-16",
        cta_url: "/offer/valentines-day-offer",
        name_of_sale: "Valentine's Day Offer",
        name_of_sale_lower: "valentine's day offer",
        slug_name: "valentines",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "Valentine's Day is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "presidents_day": {
        name: "Presidents' Day",
        short_name: "Presidents' Day",
        long_name: "Presidents' Day",
        startDate: "2026-02-13",
        endDate: "2026-02-18",
        cta_url: "/offer/presidents-day-offer",
        name_of_sale: "Presidents' Day Offer",
        name_of_sale_lower: "presidents' day offer",
        slug_name: "presidents_day",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "Presidents' Day is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "st_patrick": {
        name: "Saint Patrick's Day",
        short_name: "Saint Patrick's Day",
        long_name: "Saint Patrick's Day",
        startDate: "2026-03-13",
        endDate: "2026-03-19",
        cta_url: "/offer/saint-patrick-day-offer",
        name_of_sale: "Saint Patrick's Day Offer",
        name_of_sale_lower: "saint patrick's day offer",
        slug_name: "st_patrick",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "Saint Patrick's Day is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "easter": {
        name: "Easter",
        short_name: "Easter",
        long_name: "Easter",
        startDate: "2026-03-31",
        endDate: "2026-04-07",
        cta_url: "/offer/easter-offer",
        name_of_sale: "Easter Offer",
        name_of_sale_lower: "easter offer",
        slug_name: "easter",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "Easter is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "mothers_day": {
        name: "Mother's Day",
        short_name: "Mother's Day",
        long_name: "Mother's Day",
        startDate: "2026-05-06",
        endDate: "2026-05-12",
        cta_url: "/offer/mothers-day-offer",
        name_of_sale: "Mother's Day Offer",
        name_of_sale_lower: "mother's day offer",
        slug_name: "mothers_day",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "Mother's Day is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "memorial": {
        name: "Memorial Day",
        short_name: "Memorial Day",
        long_name: "Memorial Day",
        startDate: "2026-05-21",
        endDate: "2026-05-27",
        cta_url: "/offer/memorial-day-offer",
        name_of_sale: "Memorial Day Offer",
        name_of_sale_lower: "memorial day offer",
        slug_name: "memorial",
        adjective: "Quickest",  // A/B Test the adjectives
        adjective_lower: "quickest",
        list_of_copy: [
            "Memorial Day is the quickest opportunity you have at multiplying your revenue."
        ]
    },
    "fathers_day": {
        name: "Father's Day",
        short_name: "Father's Day",
        long_name: "Father's Day",
        startDate: "2026-06-17",
        endDate: "2026-06-23",
        cta_url: "/offer/fathers-day-offer",
        name_of_sale: "Father's Day Offer",
        name_of_sale_lower: "father's day offer",
        slug_name: "fathers_day",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "Father's Day is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "july_4th": {
        name: "4th of July",
        short_name: "4th of July",
        long_name: "4th of July",
        startDate: "2026-07-01",
        endDate: "2026-07-06",
        cta_url: "/offer/july-4th-offer",
        name_of_sale: "4th of July Offer",
        name_of_sale_lower: "4th of july offer",
        slug_name: "july_4th",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "4th of July is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "labor_day": {
        name: "Labor Day",
        short_name: "Labor Day",
        long_name: "Labor Day",
        startDate: "2026-09-04",
        endDate: "2026-09-09",
        cta_url: "/offer/labor-day-offer",
        name_of_sale: "Labor Day Offer",
        name_of_sale_lower: "labor day offer",
        slug_name: "labor_day",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "Labor Day is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "halloween": {
        name: "Halloween",
        short_name: "Halloween",
        long_name: "Halloween",
        startDate: "2026-10-27",
        endDate: "2026-11-02",
        cta_url: "/offer/halloween-offer",
        name_of_sale: "Halloween Offer",
        name_of_sale_lower: "halloween offer",
        slug_name: "halloween",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "Halloween is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "veterans_day": {
        name: "Veterans Day",
        short_name: "Veterans Day",
        long_name: "Veterans Day",
        startDate: "2026-11-09",
        endDate: "2026-11-13",
        cta_url: "/offer/veterans-day-offer",
        name_of_sale: "Veterans Day Offer",
        name_of_sale_lower: "veterans day offer",
        slug_name: "veterans_day",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "Veterans Day is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "thanksgiving": {
        name: "Thanksgiving",
        short_name: "Thanksgiving",
        long_name: "Thanksgiving",
        startDate: "2026-11-23",
        endDate: "2026-11-28",
        cta_url: "/offer/thanksgiving-offer",
        name_of_sale: "Thanksgiving Offer",
        name_of_sale_lower: "thanksgiving offer",
        slug_name: "thanksgiving",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "Thanksgiving is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "bfcm": {
        name: "Black Friday Cyber Monday",
        short_name: "BFCM",
        long_name: "Black Friday Cyber Monday",
        startDate: "2026-11-27",
        endDate: "2026-12-02",
        cta_url: "/offer/bfcm-offer",
        name_of_sale: "Black Friday Cyber Monday Offer",
        name_of_sale_lower: "black friday cyber monday offer",
        slug_name: "bfcm",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "Black Friday Cyber Monday is the biggest opportunity you have at multiplying your revenue."
        ]
    },
    "christmas": {
        name: "Christmas",
        short_name: "Christmas",
        long_name: "Christmas",
        startDate: "2026-12-20",
        endDate: "2026-12-27",
        cta_url: "/offer/christmas-offer",
        name_of_sale: "Christmas Offer",
        name_of_sale_lower: "christmas offer",
        slug_name: "christmas",
        adjective: "Biggest",  // A/B Test the adjectives
        adjective_lower: "biggest",
        list_of_copy: [
            "Christmas is the biggest opportunity you have at multiplying your revenue."
        ]
    },
}


// How many days before a holiday's startDate we begin marketing it
const HOLIDAY_LEAD_DAYS = 30;

function getActiveHoliday() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    for (const key of Object.keys(allHolidays)) {
        if (key === "standby") continue;
        const holiday = allHolidays[key];
        if (!holiday.startDate || !holiday.endDate) continue;

        const marketingStart = new Date(holiday.startDate);
        marketingStart.setDate(marketingStart.getDate() - HOLIDAY_LEAD_DAYS);

        const end = new Date(holiday.endDate);

        if (today >= marketingStart && today <= end) {
            return holiday;
        }
    }

    return allHolidays["standby"];
}

const _activeHoliday = getActiveHoliday();

export const isHolidayFocus = _activeHoliday.slug_name !== ""
export const isPromotionActive = true
export const currentHoliday = _activeHoliday


// Build default holiday incase leads visits old promotional page
export const currentHolidayShort = currentHoliday.short_name
export const currentHolidayLong = currentHoliday.long_name
export const currentHolidayName = currentHoliday.name
export const currentHolidayCTA = currentHoliday.cta_url

export const mostRecentOfferCtaUrl = _activeHoliday.cta_url || "/offer/july-4th-offer"

// Sets the timer to the days past (week days only)
const monthlyQuota = 4
const numberOfWeekdaysPast = Array.from({length: new Date().getDate()}, (_,i) => i+1)
    .filter(d => [1,2,3,4,5].includes(new Date(new Date().getFullYear(), new Date().getMonth(), d).getDay())).length;

const numberOfWeeks = parseInt(numberOfWeekdaysPast / 5)
export const currentAvailability = monthlyQuota > numberOfWeeks ? monthlyQuota - numberOfWeeks : 1
